import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import DescriptionImage from 'components/DescriptionImage';
import LazyLoadImage from 'components/LazyLoad/Image';

import ShareButtons from 'components/ShareButtons';
import styles from './styles.module.scss';

const StyledContentImage = ({
	align,
	description,
	src,
	isShareable,
	className,
	lazy = true,
	isInteractive
}) => {
	const imageCx = cx(
		styles.StyledContentImage,
		isInteractive && styles.StyledContentImage_isInteractive,
		className,
		{
			[styles[`StyledContentImage__${align}`]]: align,
			[styles.StyledContentImage_Wrap]: !lazy
		}
	);

	const content = (
		<>
			<img className={cx(styles.StyledContentImage_Image)} src={src} alt="" />
			{description ? <DescriptionImage description={description} /> : null}
			{isShareable ? (
				<div className={styles.StyledContentImage__ShareBlock}>
					<ShareButtons theme="horizontal" imageSrc={src} />
				</div>
			) : null}
		</>
	);

	return src ? (
		<div className={imageCx}>
			{lazy ? (
				<LazyLoadImage
					className={styles.StyledContentImage_Wrap}
					imageSrc={src}
				>
					{content}
				</LazyLoadImage>
			) : (
				content
			)}
		</div>
	) : null;
};

StyledContentImage.propTypes = {
	align: PropTypes.oneOf(['left', 'right']),
	description: PropTypes.string,
	src: PropTypes.string.isRequired,
	isShareable: PropTypes.bool,
	className: PropTypes.string,
	lazy: PropTypes.bool,
	isInteractive: PropTypes.bool
};

export default StyledContentImage;
